import { ArrowUp, ArrowDown } from "lucide-react";

export function SortTh({ label, k, sort, setSort, className = "", right = false }) {
  const active = sort.key === k;
  return (
    <th className={`px-4 py-2.5 text-[10px] uppercase tracking-widest text-slate-400 font-mono-num font-medium ${right ? "text-right" : ""} ${className}`}>
      <button onClick={() => setSort((s) => ({ key: k, dir: active && s.dir === "asc" ? "desc" : "asc" }))}
        data-testid={`sort-${k}`}
        className={`inline-flex items-center gap-1 hover:text-slate-200 transition-colors ${active ? "text-blue-400" : ""}`}>
        {label}
        {active && (sort.dir === "asc" ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />)}
      </button>
    </th>
  );
}

export function FilterTh({ value, onChange, testId }) {
  return (
    <th className="px-2 pb-2 pt-0 font-normal">
      <input value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} placeholder="Filter…"
        className="w-full px-2 py-1 rounded bg-slate-950 border border-slate-800 text-xs font-normal normal-case tracking-normal" />
    </th>
  );
}

export const filterRows = (rows, textOf, filters) => rows.filter((e) => {
  const t = textOf(e);
  return Object.entries(filters).every(([k, v]) => !v || String(t[k] ?? "").toLowerCase().includes(v.toLowerCase()));
});

export const sortRows = (rows, sort, keyOf) => [...rows].sort((a, b) => {
  const va = keyOf(a, sort.key);
  const vb = keyOf(b, sort.key);
  const cmp = typeof va === "number" && typeof vb === "number" ? va - vb : String(va).localeCompare(String(vb));
  return sort.dir === "asc" ? cmp : -cmp;
});
